import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ToastService} from '../../../providers/services/toast.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToastComponent {

  constructor(public toastService: ToastService) { }

}
